import { PRESCRIPTION_FULFILLMENT_OPTION } from '@abiglobalhealth/go-types'

import { usePrescription } from './usePrescription'

type UsePrescriptionFulfillmentOptionsProps = {
  prescriptionFulfillmentOptions: PRESCRIPTION_FULFILLMENT_OPTION[]
  initialFulfillmentOption: PRESCRIPTION_FULFILLMENT_OPTION | null
}

export const usePrescriptionFulfillmentOptions = (): UsePrescriptionFulfillmentOptionsProps => {
  const { prescription } = usePrescription()
  const prescriptionFulfillmentOptions = prescription?.fulfillmentOptions || []

  const initialFulfillmentOption = prescriptionFulfillmentOptions?.length === 1 ? prescriptionFulfillmentOptions[0] : null

  return { prescriptionFulfillmentOptions, initialFulfillmentOption }
}
